module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/1-90d99613bd0f464dc6a11d55a10fef0b.jpg";